
import axios from 'axios'

export default {
  getExports: (page = 1, pagination = true, filters = {}) => axios.get('/exports', { params: { page: page, pagination: pagination, ...filters } }),
  getExport: exportId => axios.get(`/exports/${exportId}`),
  postExport: (exportData) => axios.post('/exports', exportData),
  putExport: (exportId, updatedExport) => axios.put(`/exports/${exportId}`, updatedExport),
  getExportationFlow: exportationFlowId => axios.get(`/export_settings/${exportationFlowId}`),
  getExportationFlows: () => axios.get(`/export_settings`),
  postExportationFlow: (exportationFlow) => axios.post('/export_settings', exportationFlow),
  putExportationFlow: (id, exportationFlow) => axios.put(`/export_settings/${id}`, exportationFlow),
  deleteExportationFlow: (id) => axios.put(`/export_settings/delete/${id}`, {}),
  postExportHistory: (exportHistory) => axios.post('/export_setting_histories', exportHistory)
}
